export default "__VITE_ASSET__Ct6S2xwX__"